"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JourneySteps;
(function (JourneySteps) {
    JourneySteps["JourneySelection"] = "journeySelection";
    JourneySteps["Dealer"] = "dealer";
    JourneySteps["EnquiryForm"] = "enquiryForm";
    JourneySteps["Payment"] = "payment";
    JourneySteps["FinanceInsurance"] = "financeInsurance";
    JourneySteps["Finance"] = "finance";
    JourneySteps["IdentityVerification"] = "identityVerification";
    JourneySteps["Extras"] = "extras";
    JourneySteps["Accesories"] = "accesories";
    JourneySteps["HeadlessFinance"] = "headlessFinance";
})(JourneySteps = exports.JourneySteps || (exports.JourneySteps = {}));
